import React from 'react'

const ProgressBarStatusReport = ({ statusReport }) => {
  /* const getProcessAndStyle = () => {
    switch (statusReport) {
      case 'Creado':
        return {
          progress: 0,
          styleProgress: 'new',
          color: '#ADD8E6',
          name: 'Creado',
        }

      case 'Completado':
        return {
          progress: 100,
          styleProgress: 'new',
          color: '#73b971',
          name: 'Completado',
        }

      case 'Rechazar':
        return {
          progress: 100,
          styleProgress: 'new',
          color: '#9a3f1d',
          name: 'Rechazado',
        }

      case 'Pendiente':
        return {
          progress: 9,
          styleProgress: 'pending',
          color: '#FFFACD',
          name: 'Pendiente',
        }

      case 'Planificar':
        return {
          progress: 29,
          styleProgress: 'planning',
          color: '#B2F2BB',
          name: 'Planificar',
        }

      case 'Procesar':
        return {
          progress: 39,
          styleProgress: 'process',
          color: '#71b996',
          name: 'Procesar',
        }

      case 'Asignar':
        return {
          progress: 49,
          styleProgress: 'assign',
          color: '#71b9b4',
          name: 'Asignar',
        }

      case 'Validacion inicial':
        return {
          progress: 59,
          styleProgress: 'initial-validate',
          color: '#60809b',
          name: 'Validacion inicial',
        }

      case 'validacion final':
        return {
          progress: 69,
          styleProgress: 'final-validate',
          color: '#1d9a8b',
          name: 'Validacion final',
        }

      case 'Planificado':
        return {
          progress: 79,
          styleProgress: 'planned',
          color: '#FFD8B1',
          name: 'Planificado',
        }

      case 'En ejecución':
        return {
          progress: 89,
          styleProgress: 'execution',
          color: '#D8BFD8',
          name: 'En ejecución',
        }

      case 'Validar ejecución':
        return {
          progress: 99,
          styleProgress: 'execution-validate',
          color: '#FF7F50',
          name: 'Validar Ejecución',
        }

      case 'Validar cancelación':
        return {
          progress: 99,
          styleProgress: 'cancel-validate',
          color: '#FFCCCB',
          name: 'Validar Cancelación',
        }

      case 'Comunicar ejecución':
        return {
          progress: 99,
          styleProgress: 'execution-communicate',
          color: '#FFA07A',
          name: 'Comunicar Ejecución',
        }

      case 'Comunicar cancelación':
        return {
          progress: 99,
          styleProgress: 'cancel-communicate',
          color: '#FFA07A',
          name: 'Comunicar Cancelación',
        }

      case 'Cancelar':
        return {
          progress: 109,
          styleProgress: 'cancel',
          color: '#FF0000',
          name: 'Cancelado',
        }

      case 'Solucionado':
        return {
          progress: 100,
          styleProgress: 'solved',
          color: '#50C878',
          name: 'Solucionado',
        }

      case 'Cancelado':
        return {
          progress: 100,
          styleProgress: 'canceled',
          color: '#A9A9A9',
          name: 'Cancelado',
        }

      default:
        // Caso por defecto para manejar valores inesperados
        return {
          progress: 0,
          styleProgress: 'unknown',
          color: '#CCCCCC',
          name: 'Desconocido',
        }
    }
  } */

  const getProcessAndStyle = () => {
    let data = {
      progress: 0,
      color: '#CCCCCC',
      name: 'Desconocido',
    }

    if (statusReport) {
      const {
        progress = 0,
        color = '#CCCCCC',
        name = 'Desconocido',
      } = statusReport
      data = { progress, color, name }
    }
    return data
  }

  const { progress, color, name } = getProcessAndStyle()

  return (
    <div className={`progress-bar-container`}>
      <div
        className={`progress-bar`}
        style={{
          width: `${progress}%`,
          backgroundColor: color,
        }}
      ></div>{' '}
      <div className="progress-bar-text-container ">
        <span className="progress-bar-text">{name}</span>
      </div>
    </div>
  )
}

export default ProgressBarStatusReport
